import { FETCH_ACCOUNT_INFO } from '../types'
export default (state = {}, action) => {
  switch (action.type) {
    case FETCH_ACCOUNT_INFO:
      return action.payload
    default:
      return state;
  }
}
